import { Header } from './Header/Header';
import { Tabs } from './Tabs';
import { Infographics } from './Infographics/Infographics';

export { Header, Tabs, Infographics };
